import { useBehavior } from '@libs/hooks';
import { TCommonData, TLayout, TWidgetProps } from '@libs/types';
import { CoreLayoutView, TCoreLayoutStyleProps } from '@core/widgets';
import clsx from 'clsx';
import React from 'react';
import { TFloatingLayoutOption } from '../../types/options';
import styles from './css/floatingLayout.module.css';
import { useSkipFirstRender } from '@libs/utils';

export const FloatingLayout: React.FC<TWidgetProps<TCommonData, TFloatingLayoutOption> & TLayout> = ({ widget, children, margin }) => {
    const alignment = widget.options?.alignment ?? 'top';
    const { isHidden } = useBehavior(widget);
    const firstRender = useSkipFirstRender(isHidden);

    const classNames = clsx(
        styles.floatingLayout,
        styles[`aliment-${alignment}`],
        !firstRender && isHidden && alignment === 'top' && styles.fadeOutTop,
        !firstRender && isHidden && alignment !== 'top' && styles.fadeOut,
        !firstRender && !isHidden && alignment === 'top' && styles.fadeInTop,
        !firstRender && !isHidden && alignment !== 'top' && styles.fadeIn,
    );

    const styleProps: TCoreLayoutStyleProps = { margin };

    return (
        <div data-test={widget.uid} className={classNames}>
            <CoreLayoutView styleProps={styleProps} isHide={isHidden} styleName={widget.options?.style}>
                {children}
            </CoreLayoutView>
        </div>
    );
};
